import { MapDrawUpdatedEventData } from './map-draw-updated-event-data';
import { MapEvent } from './map-event';
import { MapEventType } from './map-event-type';

export class MapDrawCreatedEvent implements MapEvent {
    type = MapEventType.mapDrawCreated;
    constructor(public payload: MapDrawUpdatedEventData) {}
}
